export default __webpack_public_path__ + "static/media/logo_oap_white.a3331342.svg";